import { FormAction } from '@anytag/shared-types';
import { useQueryHelper } from '@anytag/shared-hooks';
import {
  namedOperations,
  ProposalJobDescriptionBreakDownMode,
  UserProposalSocialAcccountBudgetInput,
  useUpdateUserProposalInfluencersBudgetMutation,
  useUpdateUserProposalSocialAccountsBudgetMutation
} from '@anytag/graphql';
import { ProposeInfluencersFormValues, RowData } from '../schemaTypes';

interface SaveProposalProps {
  jdMode?: ProposalJobDescriptionBreakDownMode;
}
export const useSaveProposal = ({ jdMode }: SaveProposalProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { callUpdateUserProposalInfluencersBudget } = useUpdateUserProposalInfluencersBudgetMutation({
    refetchQueries: [namedOperations.Query.UserProposal]
  });
  const { callUpdateUserProposalSocialAccountsBudget } = useUpdateUserProposalSocialAccountsBudgetMutation({
    refetchQueries: [namedOperations.Query.UserProposal]
  });

  const handleSaveProposal =
    (tableData: RowData[]): FormAction<ProposeInfluencersFormValues>['onSubmit'] =>
    async (values, { formState, reset }) => {
      if (!formState.isDirty) return;

      try {
        if (jdMode === ProposalJobDescriptionBreakDownMode.INFLUENCER_BREAKDOWN) {
          await callUpdateUserProposalInfluencersBudget({
            variables: {
              input: {
                influencers:
                  tableData?.map(({ influencer }, index) => ({
                    influencerId: influencer.id,
                    profit: Number(values[`${index}-profit`]),
                    budget: Number(values[`${index}-budget`]),
                    influencerCost: Number(values[`${index}-influencerCost`])
                  })) || []
              }
            }
          });
        } else {
          await callUpdateUserProposalSocialAccountsBudget({
            variables: {
              input: {
                socialAccounts: tableData.reduce<UserProposalSocialAcccountBudgetInput[]>(
                  (results, { influencer, socialAccount }, index) => {
                    if (socialAccount) {
                      return [
                        ...results,
                        {
                          influencerId: influencer.id,
                          socialAccountId: socialAccount.id,
                          socialAccountMedia: socialAccount.socialMedia,
                          profit: Number(values[`${index}-profit`]),
                          budget: Number(values[`${index}-budget`]),
                          influencerCost: Number(values[`${index}-influencerCost`])
                        }
                      ];
                    }
                    return results;
                  },
                  []
                )
              }
            }
          });
        }
        enqueueSnackbar(t('succeededUpdateWhitelist'), { variant: 'success' });
        reset?.(values);
      } catch (error) {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      }
    };

  return { handleSaveProposal };
};
